<template>
  <footer class="footer-section">

    <!-- Daily Deeds Promo -->
    <router-link v-if="showDeedPromo" :to="{ name: 'dailyDeeds' }" class="d-block mb-4 text-decoration-none">
      <div class="promo-card">
        <div class="promo-icon">&#9733;</div>
        <div class="promo-content">
          <div class="promo-title">Daily Deeds Tracker</div>
          <div class="promo-desc">Track your Quraan, Dhikr, Fasting, Charity &amp; more — every single day.</div>
        </div>
        <div class="promo-arrow">&rarr;</div>
      </div>
    </router-link>

    <!-- Divider -->
    <div class="footer-divider"></div>

    <!-- Attribution -->
    <div class="footer-attribution">
      For the pleasure of Allah.
    </div>

    <!-- Legal links -->
    <div class="footer-legal">
      <router-link :to="{ name: 'about' }">About</router-link>
      <span class="footer-dot">&middot;</span>
      <router-link :to="{name:'legal', hash: '#terms' }">Terms</router-link>
      <span class="footer-dot">&middot;</span>
      <router-link :to="{name:'legal', hash: '#disclaimer' }">Disclaimer</router-link>
      <span class="footer-dot">&middot;</span>
      <router-link :to="{name:'legal', hash: '#privacy' }">Privacy</router-link>
    </div>

  </footer>
</template>

<script>
export default {
  computed: {
    showDeedPromo() {
      const name = this.$route.name;
      return name === 'khatm' || name === 'counter';
    },
  },
};
</script>

<style scoped>
.footer-section {
  padding: 0.75rem 0 0;
  text-align: center;
}
.footer-divider {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  margin: 0 0 1rem;
}
.footer-attribution {
  font-size: 13px;
  color: #888;
  margin-bottom: 0.5rem;
}
.footer-legal {
  font-size: 11px;
  color: #aaa;
  padding-bottom: 1.5rem;
}
.footer-legal a {
  color: #aaa;
  text-decoration: none;
}
.footer-legal a:hover {
  color: #666;
  text-decoration: underline;
}
.footer-dot {
  margin: 0 6px;
}

/* Promo card */
.promo-card {
  display: flex;
  align-items: center;
  padding: 14px 18px;
  border-radius: 12px;
  background: #f9f5ff;
  border: 1px solid #ece3f6;
  transition: box-shadow 0.15s, transform 0.15s;
}
.promo-card:hover {
  box-shadow: 0 2px 12px rgba(124, 92, 191, 0.12);
  transform: translateY(-1px);
}
.promo-icon {
  font-size: 20px;
  margin-right: 12px;
  color: #7c5cbf;
  flex-shrink: 0;
}
.promo-content {
  flex: 1;
  text-align: left;
}
.promo-title {
  font-size: 13px;
  font-weight: 700;
  color: #5b3a8c;
  margin-bottom: 2px;
}
.promo-desc {
  font-size: 11px;
  color: #7a6a8e;
  line-height: 1.4;
}
.promo-arrow {
  font-size: 18px;
  color: #7c5cbf;
  margin-left: 12px;
  font-weight: 700;
  flex-shrink: 0;
}
</style>
